import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=38aba066&scoped=true"
import script from "./Index.vue?vue&type=script&scoped=true&lang=js"
export * from "./Index.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=38aba066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aba066",
  null
  
)

export default component.exports